import { render, staticRenderFns } from "./law-ad-h5.vue?vue&type=template&id=6e2773c7&scoped=true&"
import script from "./law-ad-h5.vue?vue&type=script&lang=js&"
export * from "./law-ad-h5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2773c7",
  null
  
)

export default component.exports